import { useEffect, useState } from "react";
import AdminLayout from "../layouts/AdminLayout";
import { hasPermission } from "../utils/permissions"; // 🔐 Import permission guard

function AdminBanner() {
  const [banners, setBanners] = useState([]);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");

  const canView = hasPermission("banners", "view");
  const canEdit = hasPermission("banners", "edit");

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    const res = await fetch("http://kolibusiness.com/backend/get-banners.php");
    const data = await res.json();
    setBanners(data);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!canEdit) return alert("No permission to upload.");

    const formData = new FormData();
    formData.append("banner", image);

    const res = await fetch("http://kolibusiness.com/backend/upload-banner.php", {
      method: "POST",
      body: formData
    });

    if (res.ok) {
      setImage(null);
      setPreview("");
      fetchBanners();
    }
  };

  const handleDelete = async (id) => {
    if (!canEdit) return alert("No permission to delete.");
    if (!window.confirm("Delete this banner?")) return;
    await fetch(`http://kolibusiness.com/backend/delete-banner.php?id=${id}`);
    fetchBanners();
  };

  const toggleStatus = async (id, status) => {
    if (!canEdit) return alert("No permission to change status.");
    const newStatus = status === "active" ? "inactive" : "active";
    await fetch(`http://kolibusiness.com/backend/toggle-banner-status.php?id=${id}&status=${newStatus}`);
    fetchBanners();
  };

  const handleDrag = (e, fromIndex) => {
    e.dataTransfer.setData("dragIndex", fromIndex);
  };

  const handleDrop = async (e, toIndex) => {
    const fromIndex = e.dataTransfer.getData("dragIndex");
    if (fromIndex === toIndex) return;

    const reordered = [...banners];
    const [moved] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, moved);
    setBanners(reordered);

    await fetch("http://kolibusiness.com/backend/reorder-banners.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reordered.map((b) => b.id))
    });
  };

  if (!canView) {
    return (
      <AdminLayout>
        <p style={{ padding: "20px", color: "red", fontWeight: "bold" }}>
          ❌ You do not have permission to view banners.
        </p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div style={styles.container}>
        <h2 style={styles.title}>🖼️ Banner Manager</h2>

        {canEdit && (
          <>
            <form onSubmit={handleUpload} style={styles.form}>
              <input
                type="file"
                accept="image/*"
                required
                onChange={(e) => {
                  setImage(e.target.files[0]);
                  setPreview(URL.createObjectURL(e.target.files[0]));
                }}
              />
              <button type="submit" style={styles.uploadButton}>Upload</button>
            </form>

            {preview && (
              <div style={styles.previewBox}>
                <h4>Preview</h4>
                <img src={preview} alt="Preview" style={styles.previewImage} />
              </div>
            )}
          </>
        )}

        <div style={styles.grid}>
          {banners.map((b, index) => (
            <div
              key={b.id}
              style={styles.card}
              draggable={canEdit}
              onDragStart={(e) => handleDrag(e, index)}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => handleDrop(e, index)}
            >
              <img src={b.image_url} alt="Banner" style={styles.image} />
              <div style={styles.actions}>
                {canEdit && (
                  <>
                    <button onClick={() => handleDelete(b.id)} style={styles.deleteBtn}>
                      ❌ Delete
                    </button>
                    <button onClick={() => toggleStatus(b.id, b.status)} style={{
                      ...styles.statusBtn,
                      backgroundColor: b.status === "active" ? "#2ecc71" : "#95a5a6"
                    }}>
                      {b.status === "active" ? "🟢 Active" : "⚪ Inactive"}
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}

const styles = {
  container: {
    padding: 30,
    fontFamily: "Arial",
    background: "#f9f9f9"
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "20px"
  },
  form: {
    marginBottom: "20px",
    display: "flex",
    gap: "10px",
    flexWrap: "wrap"
  },
  uploadButton: {
    padding: "8px 16px",
    background: "#0984e3",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer"
  },
  previewBox: {
    marginBottom: 20
  },
  previewImage: {
    width: 300,
    border: "1px solid #ccc",
    borderRadius: "6px"
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    gap: 20
  },
  card: {
    border: "1px solid #ccc",
    padding: 10,
    width: "100%",
    maxWidth: 300,
    borderRadius: 6,
    background: "#fff",
    boxShadow: "0 0 5px rgba(0,0,0,0.1)"
  },
  image: {
    width: "100%",
    height: 150,
    objectFit: "cover",
    borderRadius: 4
  },
  actions: {
    marginTop: 10,
    display: "flex",
    justifyContent: "space-between",
    gap: "10px"
  },
  deleteBtn: {
    background: "#e74c3c",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    borderRadius: 4,
    cursor: "pointer"
  },
  statusBtn: {
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    borderRadius: 4,
    cursor: "pointer"
  }
};

export default AdminBanner;
